// /var/www/website2024/admin.siamweeds.com/myapp/src/api/api.js


const API_BASE_URL = 'https://py-maracar.afaa.website';
const API_AA_GO_URL = 'https://go.afaa.website';

export const API_URLS = {

  // ALL_USERS_BY_NAME: (userID, firstName) => `${API_BASE_URL}/register/api_env_3/all_users?user_ID=${userID}&first_name=${firstName}`,
  // ALL_USERS: (userID) => `${API_BASE_URL}/register/api_env_3/all_users?user_ID=${userID}&position_ID=2`,
  // ALL_USERS_ENV_3: (userID) => `${API_BASE_URL}/register/api_env_3/all_users?user_ID=${userID}`,
  // Consolidated ALL_USERS_BY_NAME, ALL_USERS_ENV_3, and ALL_USERS into a single function

  

  TRANSLATIONS: 'https://afaa.website/json/crm-01/InvoiceDataTranslations.json',
  FIXED_RATE: 'https://afaa.website/json/crm-01/FixedRateConnAPI.json',
  STORE_CONSTANTS: 'https://afaa.website/json/crm-01/StoreConstant.json',
  CURRENCIES: 'https://afaa.website/json/crm-01/crm-currencies.json',

  

  BOOKING_DETAILS: (bookingID) => `${API_BASE_URL}/booking/api_env_3/view?sort_by=BookingID&sort=desc&BookingID=${bookingID}`,
  CUSTOMER_DETAILS: (customerID) => `${API_BASE_URL}/register/api_env_3/user?user_ID=${customerID}`,
  BOOKING_DETAILS_EXTENDED: (bookingID) => `${API_BASE_URL}/booking/api_env_3/detail_view?BookingID=${bookingID}`,
  SERVICE_PRICE: (serviceID) => `${API_BASE_URL}/price/api_env_3/price_service?ServiceID=${serviceID}`,
  BRANCH_DETAILS: (userID) => `${API_BASE_URL}/branches/api_env_3/view?user_ID=${userID}&order_by=branch_ID&order_direction=ASC&limit=1`,
  

  ALL_USERS: (userID, firstName = '', positionID = '') =>
    `${API_BASE_URL}/register/api_env_3/all_users?user_ID=${userID}&first_name=${firstName}&position_ID=${positionID}`,

  BOOKING_NOTIFICATIONS: `${API_BASE_URL}/booking/api_env_3/detail_view_price?sort=desc`,

  UPDATE_EMPLOYEE: (bookingDetailID) => `${API_BASE_URL}/register/api_env_3/update_status?table_name=BookingsEmployeeID&id_field_name=BookingDetailID&record_id=${bookingDetailID}`,
  
  EDIT_USER: (userID) => `${API_BASE_URL}/register/api_env_3/edit?user_ID=${userID}`,
  SHOW_USER: (employeeId) => `${API_BASE_URL}/register/api_env_3/user?user_ID=${employeeId}`,
  INSERT_USER: `${API_BASE_URL}/register/api_env_3/insert`,
  POSITION_LIST: `${API_BASE_URL}/register/api/position_list`,
  STATUS_LIST: `${API_BASE_URL}/register/api/status_list`,


  SERVICES: `${API_BASE_URL}/services/api_env_3/view?status=1`,
  PRICE: `${API_BASE_URL}/price/api_env_3/view_app`,
  PRICE_FOR_BOOKING: (bookingId) => `${API_BASE_URL}/price/api_env_3/view_app?PriceID=${bookingId}`,

  BRANCHES: `${API_BASE_URL}/branches/api_env_3/view`,
  BRANCHES_LIST: `${API_BASE_URL}/branches/api_env_3/view`,

  EVENTS: `${API_BASE_URL}/booking/api_env_3/detail_calendarView`,
  CREATE_BOOKING: `${API_BASE_URL}/booking/api_env_3/create_nulllogin`,
  AVAILABLE_TIMES: `${API_BASE_URL}/booking/api_env_3/available`,
  DETAIL_CREATE: `${API_BASE_URL}/booking/api_env_3/detail_create`,
  CHECK_AVAILABILITY: `${API_BASE_URL}/booking/api_env_3/detail_calendarView?limit=5`,
  LOGIN: `${API_BASE_URL}/login/api_env_3/check`,

  IMAGE_UPLOAD: `${API_AA_GO_URL}/aachat/api/upload`,
  IMAGE_DELETE: `${API_BASE_URL}/img/api/delete`,



  DELETE_PRICE_OPTION: `${API_BASE_URL}/price/api_env_3/delete`,
  PRICE_UPDATE: `${API_BASE_URL}/price/api_env_3/update`,
  PRICE_CREATE: `${API_BASE_URL}/price/api_env_3/create`,
  PRICE_DATA: (serviceID, userID) => `${API_BASE_URL}/price/api_env_3/view?priceConn_dataID=${serviceID}&user_ID=${userID}`,

  SEND_EMAIL: `${API_BASE_URL}/send/api_env_3/email`,
  SEND_SMS: `${API_BASE_URL}/sms/api_env_3/thsms`,
  CREATE_PAYMENT: `${API_BASE_URL}/payments/api_env_3/create`,
  PAYMENTS_LIST: `${API_BASE_URL}/payments/api_env_3/view?SortBy=TransactionID&SortOrder=DESC`,
  // สามารถเพิ่มลิงค์อื่นๆ ได้ที่นี่
};

export const API_ENDPOINTS = {
  SERVICES_VIEW_TYPE: `${API_BASE_URL}/services/api_env_3/types_view`,
  SERVICES_VIEW: `${API_BASE_URL}/services/api_env_3/view`,
  SERVICES_CREATE: `${API_BASE_URL}/services/api_env_3/create`,
  SERVICES_EDIT: `${API_BASE_URL}/services/api_env_3/edit`,
  SERVICES_DELETE: `${API_BASE_URL}/services/api_env_3/delete`,
};

// Function to handle login
export const loginUser = async (email, password) => {
  const response = await fetch(API_URLS.LOGIN, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email, password })
  });

  if (!response.ok) {
    throw new Error('Login failed: Incorrect email or password.');
  }

  const data = await response.json();
  return data;
};

